export enum UseCdmDataSource {
  GET_DATA_SOURCES_REQUEST = 'GET_DATA_SOURCES_REQUEST',
  GET_DATA_SOURCES_REQUEST_DONE = 'GET_DATA_SOURCES_REQUEST_DONE',
  GET_DATA_SOURCES_REQUEST_FAILED = 'GET_DATA_SOURCES_REQUEST_FAILED',
}
